import { log } from '@/lib/log';

const dst = {
  auth: {
    initialSession: 'dst.auth.initialSession',
    stateChanged: 'dst.auth.stateChanged'
  },
  user: {
    invalidcredentials: 'dst.user.invalidcredentials',
    idtokenreceived: 'dst.user.idtokenreceived',
    userDataReceived: 'dst.user.userDataReceived'
  }
};

/**
 * Simple wrapper to dispatch a custom event
 * @param {string} name - Event name
 * @param {unknown} [detail] - Event detail data
 * @returns {boolean} Success boolean
 */
function dispatchCustomEvent(name: string, detail: unknown = null): boolean {
  log(`Dispatching custom event ${name}`, detail);

  return window.dispatchEvent(
    new CustomEvent(name, {
      detail
    })
  );
}

export { dispatchCustomEvent, dst };
